import CommomProxy from '@/components/proxy/CommomProxy'

let child_routes = [{
        path: 'serveList',
        name: 'serveList',
        component: resolve => {
            require(['@/views/homecare/serveList.vue'], resolve);
        },
        meta: {
            title: '服务列表'
        }
    },
    {
        path: 'serveDetail',
        name: 'serveDetail',
        component: resolve => {
            require(['@/views/homecare/serveDetail.vue'], resolve);
        },
        meta: {
            title: '服务详情'
        }
    },
    {
        path: 'serveOrder',
        name: 'serveOrder',
        component: resolve => {
            require(['@/views/homecare/serveOrder.vue'], resolve);
        },
        meta: {
            title: '预约订单',
            isRefresh: false,
            keepAlive: true
        }
    },
    {
        path: 'subscribe',
        name: 'subscribe',
        component: resolve => {
            require(['@/views/homecare/subscribe.vue'], resolve);
        },
        meta: {
            title: '预约须知'
        }
    },
    {
        path: 'addressList',
        name: 'addressList',
        component: resolve => {
            require(['@/views/homecare/address.vue'], resolve);
        },
        meta: {
            title: '选择地址'
        }
    },
    {
        path: 'addressEdit',
        name: 'addressEdit',
        component: resolve => {
            require(['@/views/homecare/edit.vue'], resolve);
        },
        meta: {
            title: '地址编辑'
        }
    },
    {
        path: 'addressSearch',
        name: 'addressSearch',
        component: resolve => {
            require(['@/views/homecare/search.vue'], resolve);
        },
        meta: {
            title: '地址搜索'
        }
    },
    {
        path: 'serveSelect',
        name: 'serveSelect',
        component: resolve => {
            require(['@/views/homecare/serveSelect.vue'], resolve);
        },
        meta: {
            title: '确认订单'
        }
    },
    {
        path: 'success',
        name: 'success',
        component: resolve => {
            require(['@/views/homecare/success.vue'], resolve);
        },
        meta: {
            title: '泓华医疗'
        }
    },
    {
        path: 'orderList',
        name: 'orderList',
        component: resolve => {
            require(['@/views/homecare/orderList.vue'], resolve);
        },
        meta: {
            title: '医护上门'
        }
    },
    {
        path: 'orderscore',
        name: 'orderscore',
        component: resolve => {
            require(['@/views/homecare/orderscore.vue'], resolve);
        },
        meta: {
            title: '医护上门'
        }
    },
    {
        path: 'sickbedDetail',
        name: 'sickbedDetail',
        component: resolve => {
            require(['@/views/homecare/sickbedDetail.vue'], resolve);
        },
        meta: {
            title: '家庭病床'
        }
    },
    {
        path: 'newServeList',
        name: 'newServeList',
        component: resolve => {
            require(['@/views/homecare/newServeList.vue'], resolve);
        },
    },
    {
        path: 'serviceList',
        name: 'serviceList',
        component: resolve => {
            require(['@/views/homecare/serviceList.vue'], resolve);
        },
        meta: {
            title: ''
        }
    },
    {
        path: 'newServeDetail',
        name: 'newServeDetail',
        component: resolve => {
            require(['@/views/homecare/newServeDetail.vue'], resolve);
        },
        meta: {
            title: ''
        }
    },
    {
        path: 'HPVInfo',
        name: 'HPVInfo',
        component: resolve => {
            require(['@/views/homecare/HPVInfo.vue'], resolve);
        },
        meta: {
            title: '确认订单'
        }
    },
    {
        path: 'newHPVInfo',
        name: 'newHPVInfo',
        component: resolve => {
            require(['@/views/homecare/newHPVInfo.vue'], resolve);
        },
        meta: {
            title: '确认订单'
        }
    },
    {
        path: 'HPVDetail',
        name: 'HPVDetail',
        component: resolve => {
            require(['@/views/homecare/HPVDetail.vue'], resolve);
        },
        meta: {
            title: '订单详情'
        }
    },
    {
        path: 'patrol',
        name: 'patrol',
        component: resolve => {
            require(['@/views/homecare/patrol.vue'], resolve);
        },
        meta: {
            title: '老年健康巡护'
        }
    },
    {
        path: 'secondLevel',
        name: 'secondLevel',
        component: resolve => {
            require(['@/views/homecare/secondLevel.vue'], resolve);
        },
        meta: {
            title: '',
            normal: true
        }
    },
	{
	    path: 'sickList',
	    name: 'sickList',
	    component: resolve => {
	        require(['@/views/homecare/homecareSick/sickList.vue'], resolve);
	    },
	    meta: {
	        title: '社区医养'
	    }
	},
	{
	    path: 'sickDetail',
	    name: 'sickDetail',
	    component: resolve => {
	        require(['@/views/homecare/homecareSick/sickDetail.vue'], resolve);
	    },
	    meta: {
	        title: '服务详情'
	    }
	},
]

let route = [{
    path: '/homecare',
    component: CommomProxy,
    children: child_routes
}]

export default route


// WEBPACK FOOTER //
// ./src/router/homecare.js